import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';

export interface CanComponentDeactivate {
  CanDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root'
})

export class CreateRequestGuardService implements CanDeactivate<CanComponentDeactivate> {
  router: Router;

  constructor(router: Router) {
    debugger
    this.router = router;
  }

  canDeactivate(component: CanComponentDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): boolean |
    UrlTree | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    {
    return component.CanDeactivate();
  }

}
